
export const promiseTimeout = function(promise, ms){

  // Create a promise that rejects in <ms> milliseconds
  let timeout = new Promise((resolve, reject) => {
    let id = setTimeout(() => {
      clearTimeout(id);
      reject('Timed out in '+ ms + 'ms.');
    }, ms);
  });

  // Returns a race between our timeout and the passed in promise
  return Promise.race([
    promise,
    timeout
  ]);
};

// Use to test if a promise take a long time
export const setTimeoutPromise = (timeout) => {
  return new Promise((resolve) => setTimeout(resolve, timeout));
};